import { render, staticRenderFns } from "./SaveAsTemplateModal.vue?vue&type=template&id=6d528e9c&scoped=true"
import script from "./SaveAsTemplateModal.vue?vue&type=script&lang=js"
export * from "./SaveAsTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SaveAsTemplateModal.vue?vue&type=style&index=0&id=6d528e9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d528e9c",
  null
  
)

export default component.exports